module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_4.be42a4d4.png";